import "./App.css";
import Empezar from "./pages/Empezar";
import Home from "./pages/Home";
import Sintomas from "./pages/Sintomas";
import Tests from "./pages/Tests";
import Clinicas from "./pages/Clinicas";
import Navbar from "./components/Navbar/Navbar";
import { Routes, Route } from 'react-router-dom';
import Footer from "./components/Footer/Footer";
import TestDetalle from "./components/TestDetalle/TestDetalle"

// Layout para páginas con Navbar
const LayoutWithNavbar = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      {/* <Footer /> */}
    </>
  );
};

function App() {
  return (
    <>
    <Routes>
      {/* Home sin Navbar */}
      <Route path='/' element={<Home />} />
      
      {/* Páginas con Navbar */}
      <Route path='/empezar' element={
        <LayoutWithNavbar>
          <Empezar />
        </LayoutWithNavbar>
      } />
      <Route path='/sintomas' element={
        <LayoutWithNavbar>
          <Sintomas />
        </LayoutWithNavbar>
      } />
      <Route path='/tests' element={
        <LayoutWithNavbar>
          <Tests />
        </LayoutWithNavbar>
      } />
        {/* ✅ Ruta dinámica con Navbar */}
        <Route path='/tests/:testId' element={
          <LayoutWithNavbar>
            <TestDetalle />
          </LayoutWithNavbar>
        } />
      <Route path='/clinicas' element={
        <LayoutWithNavbar>
          <Clinicas />
        </LayoutWithNavbar>
      } />
    </Routes>
    </>
  );
}

export default App;
